import { motion } from 'framer-motion';

const RegionsServed = () => {
  const regions = [
    {
      name: 'São José dos Campos e Vale do Paraíba',
      cities: ['São José dos Campos', 'Taubaté', 'Jacareí', 'Caçapava', 'Pindamonhangaba'],
    },
    {
      name: 'Grande São Paulo',
      cities: ['São Paulo Capital', 'Guarulhos', 'Santo André', 'São Bernardo', 'Osasco'],
    },
    {
      name: 'Sul de Minas Gerais',
      cities: ['Pouso Alegre', 'Poços de Caldas', 'Varginha', 'Itajubá', 'Três Corações'],
    },
    {
      name: 'Rio de Janeiro',
      cities: ['Rio de Janeiro Capital', 'Niterói', 'Duque de Caxias', 'Nova Iguaçu', 'Consultar outras'],
    },
  ];

  return (
    <section id="regioes" className="bg-[#f8f9fa] py-20">
      <div className="container mx-auto px-6 lg:px-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <div className="inline-block bg-[#ff6f00]/10 text-[#ff6f00] px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Cobertura Regional
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-[#1a237e] mb-4">
            Atendimento Logístico Empresarial no Sudeste do Brasil
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Atendemos empresas em operações locais, regionais e intermunicipais, com foco em agilidade, segurança e continuidade operacional no transporte empresarial.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {regions.map((region, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="flex justify-center mb-4">
                <div className="w-12 h-12 flex items-center justify-center">
                  <i className="ri-map-pin-line text-4xl text-[#ff6f00]"></i>
                </div>
              </div>
              <h3 className="text-xl font-bold text-[#1a237e] mb-4 text-center">{region.name}</h3>
              <ul className="space-y-2">
                {region.cities.map((city, idx) => (
                  <li key={idx} className="text-gray-600 text-sm leading-relaxed flex items-start">
                    <i className="ri-checkbox-circle-fill text-[#ff6f00] mr-2 mt-1 flex-shrink-0"></i>
                    <span>{city}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <a
            href="https://wa.me/5512991064271?text=Ol%C3%A1!%20Gostaria%20de%20um%20or%C3%A7amento%20para%20transporte%20de%20pe%C3%A7as%2Finsumos%2Fdocumentos%20para%20minha%20empresa."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center border-2 border-[#1a237e] text-[#1a237e] px-6 py-4 rounded-lg font-semibold text-base sm:text-lg hover:bg-[#1a237e] hover:text-white transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-xl sm:text-2xl mr-2 sm:mr-3"></i>
            <span className="hidden sm:inline">Consultar Atendimento na Minha Cidade</span>
            <span className="sm:hidden">Consultar Atendimento</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default RegionsServed;
